import { Component, Prop, Vue } from 'vue-property-decorator';
import {  itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxList from 'devextreme-vue/list';
import fileModule from '@/store/modules/file.module';
import moment from 'moment';
import postModule from '@/store/modules/post.module';

@Component({
    components: {    
        DxList,          
    },
})
export default class ForumResume extends Vue {

    @Prop() public mode!: string;
    @Prop() public idArea!: number;    

    public get resume(){                
        return postModule.postsResume;
    }

    public created() {                   
        postModule.getPostResume(this.idArea) .catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});                   
    }

    public getDate(date: Date) {          
        if (date.toString().charAt(0) == '0') { 
            return "";
        } else {         
            return moment(date).format('DD-MM-YYYY HH:mm');
        }
    }

    public goToDocumentManagement() {
            this.$router.push({ name: 'Foro', params: { ambitId: this.idArea.toString() } });            
    }

    public goToFile(e: any) {
        console.log(e);
        this.$router.push({ name: 'Foro-Post', params: { ambitId: this.idArea.toString(), postId: e.itemData.id } });                           
    }

    public getType(numberOfReplys: any) {
        if(numberOfReplys == 0) return true;
        return false;
    }
}
